import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from '../hooks/useTranslation';
import '../styles/LanguageSkills.css';
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";

polyfillCountryFlagEmojis();

const LanguageSkills = () => {
  const { t } = useTranslation();
  
  const languages = [
    {
      name: t('languageSkills.french'),
      level: t('languageSkills.nativeLevel'),
      proficiency: t('languageSkills.nativeProficiency'),
      flag: '🇫🇷',
      color: '#0055a4',
      skills: [
        t('languageSkills.reading'), 
        t('languageSkills.writing'), 
        t('languageSkills.speaking'), 
        t('languageSkills.listening')
      ]
    },
    {
      name: t('languageSkills.english'),
      level: t('languageSkills.advancedLevel'),
      proficiency: t('languageSkills.advancedProficiency'),
      flag: '🇺🇸',
      color: '#3c3b6e',
      skills: [
        t('languageSkills.reading'), 
        t('languageSkills.writing'), 
        t('languageSkills.speaking'), 
        t('languageSkills.listening')
      ]
    },
    {
      name: t('languageSkills.spanish'),
      level: t('languageSkills.intermediateLevel'),
      proficiency: t('languageSkills.intermediateProficiency'),
      flag: '🇪🇸',
      color: '#c60b1e',
      skills: [
        t('languageSkills.reading'), 
        t('languageSkills.basicWriting'), 
        t('languageSkills.basicSpeaking'), 
        t('languageSkills.listening')
      ]
    }
  ];

  return (
    <div className="language-skills">
      {languages.map((language, index) => (
        <motion.div
          key={language.name}
          className="language-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.2 }}
          style={{
            borderColor: language.color
          }}
        >
          <div className="language-header" style={{ backgroundColor: `${language.color}20` }}>
            <div className="language-flag">{language.flag}</div>
            <div className="language-info">
              <h3>{language.name}</h3>
              <div className="language-level">
                <span className="level-badge" style={{ backgroundColor: language.color }}>
                  {language.level}
                </span>
                <span className="level-text">{language.proficiency}</span>
              </div>
            </div>
          </div>
          
          <div className="language-skills-list">
            {language.skills.map(skill => (
              <div key={skill} className="skill-item">
                <FontAwesomeIcon 
                  icon={faCheck} 
                  className="languageskillicon" 
                  style={{ color: language.color }} 
                  size="xs" 
                />
                <span>{skill}</span>
              </div>
            ))}
          </div>
          
          <div className="language-meter">
            <div className="meter-label">{t('languageSkills.proficiency')}</div>
            <div className="meter-bar">
              <motion.div 
                className="meter-fill"
                initial={{ width: 0 }}
                animate={{ 
                  width: language.level === t('languageSkills.nativeLevel') ? '100%' : 
                         language.level === t('languageSkills.advancedLevel') ? '85%' : 
                         language.level === t('languageSkills.intermediateLevel') ? '60%' : '40%'
                }}
                transition={{ duration: 1, delay: index * 0.2 + 0.5 }}
                style={{ backgroundColor: language.color }}
              />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default LanguageSkills;
